module.exports = __webpack_public_path__ + "static/media/Chapter 2 Slide 2.099b9c17.jpg";